export const AudioFeature = {
	BRIEFING: 'briefing',
	NARRATION: 'narration',
} as const;

export type AudioFeatureType = (typeof AudioFeature)[keyof typeof AudioFeature];
